/* global axios */

import ApiClient from '../ApiClient';

class CustomerContextAPI extends ApiClient {
  constructor() {
    super('integrations/customer_context', { accountScoped: true });
  }

  get(conversationId) {
    return axios.get(this.url, { params: { conversation_id: conversationId } });
  }

  refresh(conversationId) {
    return axios.post(`${this.url}/refresh`, {
      conversation_id: conversationId,
    });
  }

  getIntegrations() {
    return axios.get(`${this.url}/integrations`);
  }

  connectPostHog({ projectId, host }) {
    return axios.post(`${this.url}/posthog/connect`, {
      project_id: projectId,
      host,
    });
  }

  disconnectPostHog() {
    return axios.post(`${this.url}/posthog/disconnect`);
  }

  connectStripe({ secretKey }) {
    return axios.post(`${this.url}/stripe/connect`, {
      secret_key: secretKey,
    });
  }

  disconnectStripe() {
    return axios.post(`${this.url}/stripe/disconnect`);
  }
}

export default new CustomerContextAPI();
